import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionWrapper from '../components/atoms/SectionWrapper';
import SellersTable from '../components/Sellers/SellersTable';

const SellersPage = () => {
  const { t } = useTranslation();
  return (
    <SectionWrapper
      title={t('sellers.title')}
      desc={t('sellers.subTitle')}
      whiteBgChildren
      data-testid="sellers-page"
    >
      <SellersTable />
    </SectionWrapper>
  );
};

export default SellersPage;
